module.exports = __webpack_public_path__ + "static/img/no_data_coupon.2f2ccbd2.png";